import { useCallback } from "react"
import { graphql, UseMutationConfig } from "react-relay"
import { type CustomMutationParams, useMutationWithErrorDialog } from "@/hooks/useMutationWithErrorDialog"
import { useFileUploadRequestMutation as useFileUploadRequestMutationType } from "@/modules/patients/services/__generated__/useFileUploadRequestMutation.graphql"
import { FileUploadRequestType } from "@/types/__generated__/union-types"

const mutation = graphql`
  mutation useFileUploadRequestMutation($input: CreateFileUploadRequestInput!) {
    createFileUploadRequest(input: $input) {
      fileUploadRequest {
        id
        ...FileUploadRequestFragment
      }
      errors {
        ... on Error {
          message
        }
      }
    }
  }
`

type Config = Omit<UseMutationConfig<useFileUploadRequestMutationType>, "variables"> & {
  requestDocumentType: FileUploadRequestType
  appointmentId: string
}

const useFileUploadRequestMutation = (params?: CustomMutationParams) => {
  const [commit, isInFlight] = useMutationWithErrorDialog<useFileUploadRequestMutationType>(mutation, params)

  const commitHandler = useCallback(
    (config: Config) => {
      const { appointmentId, requestDocumentType } = config

      commit({
        ...config,
        variables: {
          input: {
            appointmentId,
            requestDocumentType,
          },
        },
      })
    },
    [commit],
  )

  return [commitHandler, isInFlight] as const
}

export { useFileUploadRequestMutation }
